import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'components/general/Avatar';
import { useNavigate } from 'react-router-dom';
import { FaPen, FaTrash } from 'react-icons/fa';
import { cookie } from 'utils/cookies';

const Table = ({ data, handleDeleteBtn = () => {} }) => {
  const navigate = useNavigate();
  const userRole = cookie.get('user-role');

  // ✅ Apply filtering based on user role
  const filteredData =
    userRole === 'engineer'
      ? data.filter((row) => row.role === 'contractor')
      : data;

  return (
    <div className="card">
      <div className="table-responsive">
        <table className="table card-table table-vcenter text-nowrap datatable">
          <thead>
            <tr>
              <th>User</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Reporting Manager</th>
              <th className="text-end">Actions</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((row) => (
                <tr key={row.id}>
                  <td className="user_name">
                    <div className="d-flex align-items-center gap-2">
                      <Avatar
                        role={row?.role}
                        name={`${row?.name} ${row?.lastName ? row?.lastName : ''}`}
                      />
                      <span>
                        {`${row?.name} ${row?.lastName ? row?.lastName : ''}`}
                      </span>
                    </div>
                  </td>
                  <td>{row.email}</td>
                  <td>{row.phone ?? '-'}</td>
                  <td>
                    {row.reportingManager?.name
                      ? `${row.reportingManager?.name} ${
                          row.reportingManager?.lastName || ''
                        }`
                      : '-'}
                  </td>
                  <td>
                    <div className="d-flex gap-2 all_btn justify-content-end">
                      <div className="role_btn">{row.role}</div>
                      <div
                        className="edit_btn"
                        onClick={() => navigate('/usermanagement/edit/' + row.id)}
                      >
                        <FaPen />
                      </div>
                      <div
                        className="delete_btn"
                        onClick={() => handleDeleteBtn(row.id)}
                      >
                        <FaTrash />
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="user_name" colSpan="5">
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

Table.propTypes = {
  data: PropTypes.array,
  handleDeleteBtn: PropTypes.func,
};

export default Table;
